import React from "react";
import { ResponsiveType } from "../../../interface/redux/config";
import { useLanguage } from "../../../hooks/useLanguage";
import styles from "./Ci.module.css";

type Props = { Responsive: ResponsiveType };
const Cisection2 = (_: Props) => {
  const { isKr } = useLanguage();
  const details = isKr ? [
    ["여섯 모듈, 하나의 형태", "같은 형태의 모듈 여섯 개가 60°씩 회전하며 하나의 심볼을 이룹니다. 각 모듈은 독립된 윤곽을 유지하면서 전체적으로 균형을 이룹니다."],
    ["간격이 만드는 열린 중심", "모듈 사이의 일정한 틈과 열린 중심은 복잡함을 덜어내고 형태를 선명하게 만듭니다. 작은 크기에서도 여섯 모듈의 구조를 알아볼 수 있도록 정돈했습니다."],
    ["간결하고 단단한 워드마크", "대문자 HUCONN의 굵은 획과 정돈된 곡선이 심볼을 안정적으로 받쳐줍니다. 장식적인 표기를 덜어내고 회사 이름 자체에 집중했습니다."],
  ] : [
    ["Six modules, one form", "Six matching modules rotate in 60° steps to form the symbol. Each keeps its own outline while contributing to a balanced whole."],
    ["Space at the centre", "Consistent gaps and an open centre give the symbol a clear structure. The geometry is refined so that its six modules remain recognisable at small sizes."],
    ["A clear, solid wordmark", "Bold uppercase letters and refined curves give the symbol a steady foundation. The wordmark focuses on the HUCONN name, without additional decorative wording."],
  ];
  return (
    <section className={styles.meaning}>
      <div className={styles.section}>
        <p className={styles.eyebrow}>FORM & MEANING</p>
        <h2 className={styles.title}>{isKr ? "로고를 이루는 요소" : "The elements of our logo"}</h2>
        <div className={styles.meaningGrid}>
          <div className={styles.symbol}><img src="/assets/brand/huconn-symbol.svg" alt={isKr ? "60° 간격으로 배치된 여섯 모듈 심볼" : "Six-module symbol arranged in 60° steps"} /></div>
          <div>{details.map(([title, description]) => <div className={styles.detail} key={title}><h3>{title}</h3><p>{description}</p></div>)}</div>
        </div>
      </div>
    </section>
  );
};
export default Cisection2;
